module.exports = __webpack_public_path__ + "img/emilie.fe0749a6.png";